import PhotoswipeLightbox from 'photoswipe/lightbox';

import "photoswipe/dist/photoswipe.css";

import fullscreen_ui from './photoswipe-lightbox/fullscreen-ui';
import close_ui from './photoswipe-lightbox/close-ui';
import captions_ui from './photoswipe-lightbox/captions-ui';

export {
    fullscreen_ui as pswp_fullscreen_ui,
    close_ui as pswp_close_ui,
    captions_ui as pswp_captions_ui
}

export const pswp_defaults = {
    thumbSelector: 'img',
    initialZoomLevel: 'fit' as const,
    secondaryZoomLevel: 'fill' as const,
    maxZoomLevel: 1.5,
    mouseMovePan: true,
    imageClickAction: 'close' as const,
    tapAction: 'close' as const,
    doubleTapAction: 'zoom-or-close' as const,
    closeTitle: 'uždaryti (x)',
    zoomTitle: 'priartinti (z)',
    fullscreenTitle: 'per visą ekraną (f)',
    arrowPrevTitle: 'ankstesnis',
    arrowNextTitle: 'sekantis',
    pswpModule: () => import(`./photoswipe`)
}

export default PhotoswipeLightbox